import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { HttpHelperDataService } from './http-helper-data.service';
import { Configuration } from '../../app.configuration.service';
import { SecurityService } from './security.service';
import { Observable } from 'rxjs';

import { SearchFilterBase } from '../model/search/searchFilterBase';
import { FileInfo } from '../model/generic/fileInfo';

@Injectable()
export abstract class CrudDataService<T> extends HttpHelperDataService {

  constructor(protected http: HttpClient, protected configuration: Configuration, protected securityService: SecurityService) {
    super(http, configuration, securityService);
  }

  public getAll = (): Observable<T[]> => {
    return this.httpGet('Get');
  }

  public get = (id: number): Observable<T> => {
    return this.httpGet(id);
  }

  public save = (item: T): Observable<T> => {
    const toSave = JSON.stringify(item);
    return this.httpPost('Save', toSave);
  }

  public remove = (id: number): Observable<T> => {
    return this.httpPost('Remove?id=' + id);
  }

  public search = (filter: SearchFilterBase): Observable<T> => {
    const toFilter = JSON.stringify(filter);
    return this.httpPost('Search', toFilter);
  }

  public SearchExcel = (filter: SearchFilterBase): Observable<FileInfo> => {
    const toSend = JSON.stringify(filter);
    return this.httpPostGetFile('SearchExcel', toSend);
  }

  public httpGetFiles: any = (actionName: string, params?: any): Observable<FileInfo[]> => {
    return this.httpGetFiles(actionName, params);
  }
}
